import React from 'react';
import styled from '@emotion/styled';
import { Css, Responsive } from '@/ui';
import { Color } from '../../../../styles/Color';
import { FONT_FAMILY_INTER } from '../../../../styles/Font';

interface IJobTypeBadgeProps {
	type: string;
}

export default function JobTypeBadge({ type }: IJobTypeBadgeProps) {
	return (
		<StyledJobTypeBadge>
			<div>{type}</div>
		</StyledJobTypeBadge>
	);
}

const StyledJobTypeBadge = styled.div`
	background-color: ${Color.OnPrimarySurface};
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(16)};
	border-radius: 4px;
	border: 1px solid ${Color.Neutral80};
	color: ${Color.OnBackgroundText};
	font-weight: 300;
	font-size: ${Css.pxToRem(18)};
	font-family: ${FONT_FAMILY_INTER};
	min-width: ${Css.pxToRem(112)};
	width: 100%;
	white-space: nowrap;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(4)} ${Css.pxToRem(8)};
	}
`;
